module.exports = __webpack_public_path__ + "img/prep_talk.6463385e.png";